/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import LayoutOperation from "../../components/layout_operation";
import {  Input, Select, Table } from "antd";
import { RightOutlined, LeftOutlined, } from "@ant-design/icons";
import Cookies from "js-cookie";
import {  Ui } from "../../services";
// import { useSelector } from "react-redux";
import { changeLang } from "../../actions/langAction";
import { connect } from "react-redux";
import ServiceApi from "../../services/ServiceApi";
import { Link } from "react-router-dom";
// import VirtualList from 'react-virtual-list';
import {
  List,
  CellMeasurerCache,
  CellMeasurer,
  AutoSizer,
} from "react-virtualized";

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 50,
});

const { Option } = Select;
// const listHeight = 700;
// const rowHeight = 300;
// const rowWidth = 586;
// const MyList = ({
//   virtual,
//   itemHeight,
//   job_id,
//   data_translate
// }) => (
//   <ul style={virtual.style}>
//     {virtual.items.map((item,index) => (
//      <Fragment>
//        {console.log(virtual.items)}
//       {/* {index==0? <div style={{height: itemHeight }}></div> : null} */}
//           <Ui.CardJob
//           key={index}
//           list={item}
//           sel_id={job_id}
//           data_translate={data_translate}
//           />
//     </Fragment>
//     ))}
//   </ul>
// );
// const MyVirtualList = VirtualList()(MyList);

function setCookies(job_id, job_progress_id, job_type_id, job_status) {
  const CompanyID = Number(Cookies.get("companyid"));
  if (CompanyID === 3) {
    window.open("/MaxiOperation/full_detail_job/" + job_id);
    // Cookies.set("job_id", job_id);
    // Cookies.set("job_progress_id", job_progress_id);
    // Cookies.set("job_type_id", job_type_id);
    // Cookies.set("job_status", job_status);
    // setTimeout(function () {
    //   window.location.assign("/MaxiOperation/full_detail_job");
    // }, 1000);
  } else {
    Cookies.set("job_id", job_id);
    Cookies.set("job_progress_id", job_progress_id);
    Cookies.set("job_type_id", job_type_id);
    Cookies.set("job_status", job_status);
    setTimeout(function () {
      window.location.assign("/MaxiOperation/full_detail_job");
    }, 1000);
  }
}
class MaxiOperation extends Component {
  constructor(props) {
    super(props);
    this.handlerItem = this.handlerItem.bind(this);
    this.myRef = React.createRef();
    this.state = {
      marginRight: 626,
      open: true,
      category: [],
      priority: [
        { value: 3, text: "High" },
        { value: 2, text: "Normal" },
        { value: 1, text: "Low" },
        // { value: "", text: "All Priority" },
      ],
      loading: true,
      active: 0,
      data: [],
      data_inform: [],
      data_onprocess: [],
      filter: {
        category: "",
        priority: null,
        search_text: "",
      },
      alljob: 0,
      onprocess: 0,
      noassign: 0,
      statustab: 1,
      sum_approve: 0,
      Urgent_total: 0,
      High_total: 0,
      Normal_total: 0,
      Low_total: 0,
      job_id: 0,
      scrollTop: 0,
      data_translate: [],
      factupdate: false,
      SetDataMap: [],
      factMenuLeft: false,
      WorkFlow: [],
      data_list: [],
      colum_map: [
        {
          title: "Job No",
          dataIndex: "",
          key: "",
          render: (item) => (
            <Link
              onClick={() =>
                setCookies(
                  item.job_id,
                  item.job_progress_id,
                  item.job_type_id,
                  item.job_status
                )
              }
              // to="/MaxiOperation/full_detail_job"
              className="c-blue text-underline"
            >
              {item.job_no}
            </Link>
          ),
          sorter: (a, b) => b.job_id - a.job_id,
        },
        {
          title: "Job category",
          dataIndex: "job_category_name",
          key: "job_category_name",
        },
        {
          title: "Asset type",
          dataIndex: "asset_type",
          key: "asset_type",
        },
        {
          title: "Priority",
          dataIndex: "priority_level",
          key: "priority_level",
          render: (item) => (
            <div>
              {item == "1" ? (
                <b style={{ color: "#618817", fontWeight: 300 }}>Low</b>
              ) : null}
              {item == "2" ? (
                <b style={{ color: "#E8CD00", fontWeight: 300 }}>Normal</b>
              ) : null}
              {item == "3" ? (
                <b style={{ color: "#E09307", fontWeight: 300 }}>High</b>
              ) : null}
            </div>
          ),
        },
        {
          title: "Status",
          dataIndex: "",
          key: "",
          render: (item) => (
            <div>
              {item.job_status === 2 ||
              item.job_status === 3 ||
              item.job_status === 31 ? (
                item.job_status === 2 ? (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                ) : (
                  <span className="badge badge-pill badge-light on-process font-thai-b font14">
                    <span className="dot-on-process mr-2"></span>
                    {item.job_status_name}
                  </span>
                )
              ) : (
                <span className="badge badge-pill badge-light font-thai-b font14">
                  {item.job_status === 0 ? item.job_status_name : null}
                  {item.job_status === 1 ? item.job_status_name : null}
                  {item.job_status === 18 ? item.job_status_name : null}
                  {item.job_status === 4 ? item.job_status_name : null}
                  {item.job_status === 5 ? item.job_status_name : null}
                  {item.job_status === 7 ? item.job_status_name : null}
                  {item.job_status === 999 ? item.job_status_name : null}
                </span>
              )}
            </div>
          ),
        },
      ],
      master_inform: [],
      sideBarType: window.matchMedia("(min-width: 768px)").matches,
    };
  }
  handlerItem(id) {
    var jobno = [];
    var jobid = [];
    var setjobno = this.state.data_list.find(
      (element) => element.job_id === id
    );
    var setmapdata = this.state.data_list.filter(
      (element) =>
        element.location_lat === setjobno.location_lat &&
        element.location_lon === setjobno.location_lon
    );
    this.setState({ factMenuLeft: true, SetDataMap: setmapdata });
  }
  async componentDidMount() {
    if (Cookies.get("OperationToken") === undefined) {
      window.location.assign(ServiceApi.absoluteUrl("/login"));
    }
    document.title = "MaxiOperation";
    const getalljob = await ServiceApi.post("oper_get_query_group_list", {
      company_id: "1",
      operator_id: "0",
      project_id: "0",
      query_id: "1,2",
      query_module: "oper",
      param_text:
        "@company_id:$" +
        Cookies.get("companyid") +
        "##@operator_id:$" +
        Cookies.get("operator_id") +
        "##@project_id:$" +
        Cookies.get("project_id"),
      where_cond: "",
    });
    // const getalljob = await ServiceApi.post("v4/get_ma_list_job_V2", {
    //   i_select: null,
    //   job_status: null,
    //   category_id: null,
    //   select_date: 1,
    //   job_type_id: null,
    //   prority_id: null,
    //   username: Cookies.get("username"),
    //   company_id: Cookies.get("companyid"),
    //   operator_id: Cookies.get("operator_id"),
    //   project_id: Cookies.get("project_id"),
    //   sql_where: "and job_status not in (999)",
    // });
    const category = await ServiceApi.post("get_job_category_V2", {
      company_id: parseInt(Cookies.get("companyid")),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
      // operator_id: Cookies.get("operator_id"),
    });
    const data_language = await ServiceApi.post("master_language_detail_get", {
      // company_id: 1,
      company_id: parseInt(Cookies.get("companyid")),
      page_id: 1,
    });
    const InformData = await ServiceApi.post("tab_list_inform", {
      //company_id: 1,
      company_id: parseInt(Cookies.get("companyid")),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      create_by: Cookies.get("userId"),
      v_where: "",
    });
    /*  category.data.data.result_data.push({
      job_category_id: null,
      job_category_name: "All Job Category",
    }); */
    console.log("getalljob", getalljob);
    if(!getalljob.data.data.result_count_priority) {
      window.location.assign(ServiceApi.absoluteUrl("/login"));
    }
    
    await this.setState({
      data: getalljob.data.data?.result_ma_job_list,
      data_list: getalljob.data.data.result_ma_job_list,
      data_inform: InformData.data.data.result,
      // alljob: getalljob.data.data.result_job_status[0].total_job,
      // onprocess: getalljob.data.data.result_job_status[0].on_process,
      // noassign: getalljob.data.data.result_job_status[0].no_assign,
      Urgent_total: getalljob.data.data.result_count_priority[0].urgent,
      High_total: getalljob.data.data.result_count_priority[0].heigh,
      Normal_total: getalljob.data.data.result_count_priority[0].normal,
      Low_total: getalljob.data.data.result_count_priority[0].low,
      category: category.data.data.result_data,
      data_translate: JSON.parse(
        data_language.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
      ),
      loading: false,
      WorkFlow: getalljob.data.data.result_BasicDataProcessWF,
      // sum_approve: getalljob.data.data.result_job_status[0].approved,
      master_inform: InformData.data.data.result,
      factupdate: true,
    });

    const handler = (e) => this.setState({ sideBarType: e.matches });
    window.matchMedia("(min-width: 768px)").addEventListener("change", handler);
  }

  onCollapse() {
    if (this.state.sideBarType) {
      if (this.state.open === true) {
        this.setState({
          open: false,
          marginRight: 0,
        });
        document.getElementById("rightCardNav").style.width = "0px";
        // document.getElementById("CollapseArrow").style.marginRight = "0";
      } else {
        // document.getElementById("CollapseArrow").style.marginRight = "626";
        document.getElementById("rightCardNav").style.width = "626px";
        this.setState({
          open: true,
          marginRight: 626,
        });
      }
    } else {
      if (this.state.open === true) {
        this.setState({
          open: false,
          marginRight: 0,
        });
        document.getElementById("rightCardNav").style.width = "0px";
        // document.getElementById("CollapseArrow").style.marginRight = "0";
      } else {
        // document.getElementById("CollapseArrow").style.marginRight = "626";
        document.getElementById("rightCardNav").style.width = "100%";
        this.setState({
          open: true,
          marginRight: 626,
        });
      }
    }
  }

  handleFilterAndSearch(type, value) {
    if (this.state.statustab === 1) {
      let this_filter = {
        category:
          type == "job_category_id"
            ? value
            : !this.state.filter.category
            ? null
            : this.state.filter.category,
        priority:
          type == "priority_level"
            ? value
            : !this.state.filter.priority
            ? null
            : this.state.filter.priority,
        search_text:
          type == "input_search"
            ? value
            : !this.state.filter.search_text
            ? ""
            : this.state.filter.search_text,
      };
      let data_filter = this.state.data.filter((item) => {
        return (
          (parseInt(item["job_category_id"]) ==
            parseInt(this_filter.category) ||
            !this_filter.category) &&
          (parseInt(item["priority_level"]) == parseInt(this_filter.priority) ||
            !this_filter.priority) &&
          Object.keys(item).some((k) =>
            String(item[k])
              .toLowerCase()
              .includes(
                (!this_filter.search_text
                  ? ""
                  : this_filter.search_text
                ).toLowerCase()
              )
          )
        );
      });
      this.setState({
        data_list: data_filter,
        filter: this_filter,
      });
    } else {
      const tempFilteredData = this.state.master_inform.filter((o) =>
        Object.keys(o).some((k) =>
          String(o[k]).toLowerCase().includes(value.toLowerCase())
        )
      );
      this.setState({
        data_inform: tempFilteredData,
      });
    }
  }
  onScroll = () => {
    // const scrollY = window.scrollY //Don't get confused by what's scrolling - It's not the window
    // const scrollTop = this.myRef.current.scrollTop
    // console.log(`onScroll, window.scrollY: ${scrollY} myRef.scrollTop: ${scrollTop}`)
    // this.setState({
    //   scrollTop: scrollTop
    // })
  };

  renderRow = ({ index, parent, key, style }) => {
    const { data_translate, job_id, statustab, data_list, data_inform } =
      this.state;
    return (
      <CellMeasurer
        key={index}
        cache={cache}
        parent={parent}
        columnIndex={0}
        rowIndex={index}
      >
        <div key={key} style={style}>
          {index == 0 ? <div style={{ height: "50px" }}></div> : null}
          <Ui.CardJob
            key={index}
            list={data_list[index]}
            sel_id={job_id}
            data_translate={data_translate}
          />
        </div>
      </CellMeasurer>
    );
  };

  renderListJob() {
    const {
      marginRight,
      category,
      priority,
      loading,
      active,
      data,
      statustab,
      data_onprocess,
      job_id,
      sideBarType,
    } = this.state;
    return (
      <div className="rightnav-job position-absolute" id="rightCardNav">
        <div
          className="d-flex justify-content-between align-items-center"
          style={{ backgroundColor: "#fff", paddingRight: "20px" }}
        >
          <ul className="nav">
            <li className="nav-item font12 font-mont-sb mr-1">
              <a
                onClick={() => this.setState({ statustab: 1 })}
                className={
                  this.state.statustab === 1 ? "nav-link active" : "nav-link"
                }
              >
                {this.state.factupdate === true ? (
                  <span className="font-thai-b" style={{ fontSize: "16px" }}>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_alljob"
                      ]
                    }
                  </span>
                ) : null}{" "}
              </a>
            </li>
            <li className="nav-item font12 font-mont-sb mr-1">
              <a
                onClick={() => this.setState({ statustab: 2 })}
                className={
                  this.state.statustab === 2 ? "nav-link active" : "nav-link"
                }
              >
                {this.state.factupdate === true ? (
                  <span className="font-thai-b" style={{ fontSize: "16px" }}>
                    {/* {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_onprocess"
                      ]
                    } */}
                    Inform Problem
                  </span>
                ) : null}{" "}
              </a>
            </li>
          </ul>
          <Link
            to={
              this.state.statustab === 1 ? "/ma_list" : "/inform_problem_list"
            }
            className="font-mont-m font12"
            style={{ color: "#6F6F6F" }}
          >
            <img src={ServiceApi.absoluteUrl("/icon/list.svg")} />
            {this.state.factupdate === true ? (
              <span>
                {this.state.data_translate[Cookies.get("locale")]["list"]}
              </span>
            ) : null}{" "}
          </Link>
        </div>
        <div className="wrapper-list-job" onScroll={this.onScroll}>
          <div
            className="position-fixed"
            style={{
              zIndex: 2,
              opacity: 1,
              paddingTop: "20px",
              paddingBottom: "20px",
              top: "103px",
              backgroundColor: "#f2f3f5",
              width: "auto",
            }}
          >
            {this.state.statustab === 1 ? (
              <Input.Group
                compact
                className="d-inline"
                // style={{ maxWidth: "70%" }}
              >
                <Select
                  style={{ width: sideBarType ? "130px" : "95%" }}
                  placeholder="Job Category"
                  allowClear={true}
                  onChange={(value) =>
                    this.handleFilterAndSearch("job_category_id", value)
                  }
                >
                  {category.map((item, index) => (
                    <Option key={index} value={item.job_category_id}>
                      {item.job_category_name}
                    </Option>
                  ))}
                </Select>
                <Select
                  // style={{ width: "130px" }}
                  style={{ width: sideBarType ? "130px" : "95%" }}
                  placeholder="Priority"
                  allowClear={true}
                  onChange={(value) =>
                    this.handleFilterAndSearch("priority_level", value)
                  }
                >
                  {priority.map((item, index) => (
                    <Option key={index} value={item.value}>
                      {item.text}
                    </Option>
                  ))}
                </Select>
                <Input.Search
                  placeholder="Search Job No"
                  onSearch={(value) =>
                    this.handleFilterAndSearch("input_search", value)
                  }
                  // style={{ width: "335px" }}
                  style={{
                    width: sideBarType ? "335px" : "95%",
                    maxWidth: "100%",
                  }}
                />
              </Input.Group>
            ) : (
              <>
                <Input.Group
                  compact
                  className="d-inline"
                  style={{ width: sideBarType ? "569px" : "95%" }}
                >
                  <Input
                    placeholder="Search Job No "
                    onChange={(e) =>
                      this.handleFilterAndSearch("input_search", e.target.value)
                    }
                    style={{ maxWidth: "100%" }}
                  />{" "}
                </Input.Group>
              </>
            )}
          </div>
          {this.state.statustab == 1 ? (
            loading === false ? (
              // this.state.data_list.map((item, index) => (
              <Fragment /*key={index}*/>
                {/* {index==0? <div style={{height:"73px"}}></div> : null}
                  <Ui.CardJob
                    key={index}
                    list={item}
                    sel_id={job_id}
                    data_translate={this.state.data_translate}
                  /> */}
                <AutoSizer>
                  {({ height, width }) => (
                    <List
                      width={width}
                      height={height}
                      deferredMeasurementCache={cache}
                      rowHeight={cache.rowHeight}
                      rowRenderer={this.renderRow}
                      rowCount={this.state.data_list.length}
                    />
                  )}
                </AutoSizer>
              </Fragment>
            ) : // ))

            null
          ) : (
            //   <Fragment>
            //   <AutoSizer>
            //   {({height, width}) => (
            //     <List
            //     width={width}
            //     height={height}
            //     deferredMeasurementCache={cache}
            //     rowHeight={cache.rowHeight}
            //     rowRenderer={this.renderRow}
            //     rowCount={this.state.data_inform.length} />
            //   )}
            //  </AutoSizer>
            //  </Fragment>
            this.state.data_inform.map((item, index) => (
              <Fragment key={index}>
                {index === 0 ? <div style={{ height: "50px" }}></div> : null}
                <Ui.CardInform
                  key={index}
                  list={item}
                  sel_id={job_id}
                  data_translate={this.state.data_translate}
                />
              </Fragment>
            ))
          )}
        </div>
      </div>
    );
  }
  renderListJobNo() {
    const { SetDataMap } = this.state;
    return (
      <div
        className="sidemap position-fixed"
        style={{
          marginTop: "7%",
          width: "40%",
          marginLeft: "5%",
          padding: "10px",
        }}
      >
        {/* <ul className="nav flex-column">
          {SetDataMap.jobno.map((item, index) => (
            <li className="nav-item" key={index}>
              <a
                className={
                  index === this.props.active ? "nav-link active" : "nav-link"
                }
                onClick={() =>
                  this.setState({ job_id: SetDataMap.jobid[index] })
                }
              >
                <span className="text-center"> {item}</span>
              </a>
            </li>
          ))}
        </ul> */}
        <div className="row mb-2">
          <div className="col-12" style={{ textAlign: "right" }}>
            <button
              type="button"
              className="close"
              aria-label="Close"
              style={{ marginTop: "-10px" }}
              onClick={() => this.setState({ factMenuLeft: false })}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <Table
          columns={this.state.colum_map}
          dataSource={SetDataMap}
          size="small"
        />
      </div>
    );
  }
  renderStatShort() {
    return (
      <div className="col-9">
        <div className="row">
          <div
            className="col text-center"
            style={{ borderRight: "2px solid #f6f7fd" }}
          >
            <span
              style={{ fontSize: "24px", color: "#ffffff", fontWeight: "400" }}
            >
              {this.state.factupdate === true ? (
                <span>
                  {
                    this.state.data_translate[Cookies.get("locale")][
                      "status_high"
                    ]
                  }
                </span>
              ) : null}
            </span>
            <span
              className="ml-3"
              style={{ fontSize: "24px", color: "#E09307", fontWeight: "400" }}
            >
              {
                this.state.data_list.filter(
                  (item) => item.priority_level == "3"
                ).length
              }{" "}
            </span>
          </div>
          <div
            className="col text-center"
            style={{ borderRight: "2px solid #f6f7fd" }}
          >
            <span
              style={{ fontSize: "24px", color: "#ffffff", fontWeight: "400" }}
            >
              {this.state.factupdate === true ? (
                <span>
                  {
                    this.state.data_translate[Cookies.get("locale")][
                      "status_normal"
                    ]
                  }
                </span>
              ) : null}
            </span>{" "}
            <span
              className="ml-3"
              style={{ fontSize: "24px", color: "#E8CD00", fontWeight: "400" }}
            >
              {
                this.state.data_list.filter(
                  (item) => item.priority_level == "2"
                ).length
              }
            </span>
          </div>

          <div className="col text-center">
            <span
              style={{ fontSize: "24px", color: "#ffffff", fontWeight: "400" }}
            >
              {this.state.factupdate === true ? (
                <span>
                  {
                    this.state.data_translate[Cookies.get("locale")][
                      "status_low"
                    ]
                  }
                </span>
              ) : null}
            </span>
            <span
              className="ml-3"
              style={{ fontSize: "24px", color: "#80D51D", fontWeight: "400" }}
            >
              {
                this.state.data_list.filter(
                  (item) => item.priority_level == "1"
                ).length
              }
            </span>
          </div>
        </div>
      </div>
    );
  }
  renderStatFull() {
    return (
      <Fragment>
        <div className="col-9">
          <div className="row">
            <div
              className="col text-center"
              style={{ borderRight: "2px solid #f6f7fd" }}
            >
              <span
                style={{
                  fontSize: "24px",
                  color: "#ffffff",
                  fontWeight: "400",
                }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_high"
                      ]
                    }
                  </span>
                ) : null}
              </span>
              <span
                className="ml-3"
                style={{
                  fontSize: "24px",
                  color: "#E09307",
                  fontWeight: "400",
                }}
              >
                {this.state.High_total}{" "}
              </span>
            </div>
            <div
              className="col text-center"
              style={{ borderRight: "2px solid #f6f7fd" }}
            >
              <span
                style={{
                  fontSize: "24px",
                  color: "#ffffff",
                  fontWeight: "400",
                }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_normal"
                      ]
                    }
                  </span>
                ) : null}
              </span>{" "}
              <span
                className="ml-3"
                style={{
                  fontSize: "24px",
                  color: "#E8CD00",
                  fontWeight: "400",
                }}
              >
                {this.state.Normal_total}
              </span>
            </div>
            <div className="col text-center">
              <span
                style={{
                  fontSize: "24px",
                  color: "#ffffff",
                  fontWeight: "400",
                }}
              >
                {this.state.factupdate === true ? (
                  <span>
                    {
                      this.state.data_translate[Cookies.get("locale")][
                        "status_low"
                      ]
                    }
                  </span>
                ) : null}
              </span>
              <span
                className="ml-3"
                style={{
                  fontSize: "24px",
                  color: "#80D51D",
                  fontWeight: "400",
                }}
              >
                {this.state.Low_total}
              </span>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
  render() {
    const {
      marginRight,
      open,
      data,
      loading,
      job_id,
      factMenuLeft,
      sideBarType,
    } = this.state;
    return (
      <LayoutOperation>
        <div className="wrapper-content-operation position-relative">
          <div
            className="wrapper-content-operation-cell position-relative"
            style={{ marginRight: sideBarType ? marginRight : 0 }}
          >
            <div className="wrapper-header d-flex align-items-center mt-0">
              <div className="container-fluid">
                <div className="row align-items-center font-thai-b">
                  {open === true
                    ? this.renderStatShort()
                    : this.renderStatFull()}
                  <div className="col-3 text-right">
                    <Link to="/addjob" className="btn btn-sm btn-warning mr-2">
                      <img
                        src={ServiceApi.absoluteUrl("/icon/add_job.svg")}
                        width="14"
                        className="mr-2"
                      />
                      {this.state.factupdate === true ? (
                        <span
                          className="font-thai-b"
                          style={{ fontSize: "16px" }}
                        >
                          {
                            this.state.data_translate[Cookies.get("locale")][
                              "add_job"
                            ]
                          }
                        </span>
                      ) : null}{" "}
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            {loading === false ? (
              <Ui.Map
                zoom={12}
                data={this.state.data_list}
                center={{ lat: 13.7541588, lng: 100.5091329 }}
                triggerParentUpdate={this.handlerItem.bind(this)}
              />
            ) : null}

            {factMenuLeft ? this.renderListJobNo() : null}
          </div>

          <div
            className="collapse-list-job position-absolute"
            // id="CollapseArrow"
            style={{ marginRight: marginRight }}
          >
            <a
              className="c-yellow text-center w-100"
              onClick={() => this.onCollapse()}
            >
              {open == true ? (
                <RightOutlined className="w-100" />
              ) : (
                <LeftOutlined className="w-100" />
              )}
            </a>
          </div>
        </div>
        {this.renderListJob()}
      </LayoutOperation>
    );
  }
}
const mapStateToProps = (state) => ({
  lang: state.lang,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(MaxiOperation);
